import useLabels from "../hooks/useLabels";
import { ActionLink } from "@wine2trace/ui/FormComponents";
import PageHeader from "./PageHeader";

// Shown to a logged user who opens a page the account type or the permissions of the winery do not allow
// (route guards redirect here), and for unknown routes.
const Unauthorized = () => {
  const [getLabel] = useLabels();

  return (
    <div className="primary_container">
      <div className="detail_page">
        <PageHeader title={getLabel("unauthorized")} />
        <p>{getLabel("notEnoughPrivileges")}</p>
        <ActionLink to="/" icon="fa-arrow-right">
          {getLabel("homeNavLink")}
        </ActionLink>
      </div>
    </div>
  );
};

export default Unauthorized;
